import React, { Component } from "react";
import { Link, withRouter, Redirect } from "react-router-dom";
import Header from "./content/header"
import {Helmet} from 'react-helmet'
import api from "../../services/api"

class MeuscursosUser extends Component {

  state = {
    faturas:[],
    linktopay:null,
    codepay:null,
    statuspay:null,
    page:1
  }


  async shouldComponentUpdate(nextProps, nextState){

    if(nextState.idpay!==this.state.idpay){
      nextState.statuspay="Carregando";
      this.pay(nextState.idpay);
    }
    return true;
  }



  async pay(idpay){

    const response = await api.post("/fatura/pay", {idfatura:idpay});
    this.setState({
      codepay:response.data.status_request.bank_slip.digitable_line
    });

    window.open(response.data.status_request.bank_slip.url_slip_pdf);
    this.setState({
      statuspay:""
    });


  }



  async componentDidMount(){
    document.getElementById("faturamenu").classList.toggle("bg-light");

    const response = await api.post("/fatura/list",{page:this.state.page});
    this.setState({
      faturas:response.data
    })
    
   

  }


    togglemenu = ()=> {
        document.getElementById("sidebar").classList.toggle("active");
        document.getElementById("content").classList.toggle("active");
    }

  render() {
  
    const widthtable ={
      width:'144px',
    }

    return (
        
      <React.Fragment>
        <Header />
        <Helmet>
            <title>Mensalidades | Faculdade Olga Mettig</title>
        </Helmet>

<div class="page-content white" id="content">
  

  <button id="sidebarCollapse" onClick={this.togglemenu} type="button" class="btn btn-light bg-white rounded-pill shadow-sm px-4 mb-4"><i class="fa fa-bars mr-2"></i><small class="text-uppercase font-weight-bold">Toggle</small></button>
  
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item"><a href="/user">Pagina Inicial</a></li>
            <li class="breadcrumb-item"><a href="/user/cursos">Mensalidades</a></li>
        </ol>
    </nav>

  
 
  <div class="separator"></div>
  
  <div class="row text-black contentp">
    
    <div class="col-lg">
    <center><h4>Mensalidades</h4></center>
    <br></br>
    <center>{this.state.statuspay && <p>{this.state.statuspay}</p>}</center>
    <table id="tabela" class="table table-striped table-bordered">
  <thead class="blue white-text">
    
    <tr>
      <th scope="col">#ID</th>
      <th scope="col">Nome Curso</th>
      <th scope="col">Valor Pagamento</th>
      <th scope="col">Valor com Desconto</th>
      <th scope="col">Vencimento</th>
      <th scope="col">Status</th>
    </tr>
  </thead>
  <tbody>
  {this.state.faturas.map(el => (
    <tr>
      <th scope="row">{el.id}</th>
      <td><center><a href={'/pos-graduacao/'+el.matriculas.pos_curso.longnome+'/'+el.matriculas.pos_curso.id+''} target="_blank">{el.matriculas.pos_curso.nome}</a></center></td>
      <td ><center>R${el.valorinteiro}</center></td>
      <td><center>R${el.valorinteiro-el.valordesconto}</center></td>
      <td><center>{el.diavencimento}</center></td>
     


     
      <td>
      {
      el.status==0 && 
      <button class="btn btn-light btn-sm">Cancelado</button>
      }

      {
      el.status==1 && 
      <a onClick={e => this.setState({ idpay: el.id} )} class="btn btn-danger btn-sm">Pagar</a>
      }
      

      { 
      el.status==2 && 
      <button class="btn btn-success btn-sm">Pago</button>
      }

      {
      el.status==3 && 
      <button class="btn btn-light btn-sm">Reembolsado</button>
      }


      
      
      </td>
    </tr>
  ))}

    
  </tbody>
</table>

<nav aria-label="Page navigation example">
  <ul class="pagination">
    <li class="page-item"><a class="page-link" href="#">1</a></li>
    <li class="page-item"><a class="page-link" href="#">2</a></li>
    <li class="page-item"><a class="page-link" href="#">3</a></li>
  </ul>
</nav>



    </div>
   

  </div>

</div>


      </React.Fragment>
       
    );
  }
}

export default withRouter(MeuscursosUser);


// WEBPACK FOOTER //
// ./src/pages/User/faturas.js